import { ICreateInspecaoObraUseCase } from "../../../presentation/useCases/create/create_inspecao_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateInspecaoObraUseCase
 */

export class CreateInspecaoObraUseCase implements ICreateInspecaoObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createInspecaoObra(
    idObraChecklistServico: number,
    data: Date,
    campo1: string | null,
    campo2: string | null,
    campo3: string | null,
    campo4: string | null,
  ): Promise<void> {
    await this.repository.createInspecaoObra(
      idObraChecklistServico,
      data,
      campo1,
      campo2,
      campo3,
      campo4,
    );
  }
}
